/** The theme colour a change is drawn in. */
export type ChangeTone = 'success.main' | 'error.main' | 'text.primary';

/** Colour for a change: up is positive, down is negative, flat is neither. */
export function changeTone(value: number): ChangeTone {
  if (value > 0) return 'success.main';
  if (value < 0) return 'error.main';
  return 'text.primary';
}
